export default {
  'statusCodes.Status_code': '状态码',
  'statusCodes.Total': '总计',
  'statusCodes.title': '状态码报告',
  'statusCodes.subTitle': '（请按照utc+8的时区查看数据。）',
  'statusCodes.Request': '请求',
};
